// Interpreter ("translation") line coaches dial when a participant needs one.
// The dial pad's phone number field is pre-seeded with "+1", so both the
// displayed and the copied number omit the country code: what is shown on
// screen is exactly what lands on the clipboard, modulo formatting (KAN-2387).
export const TRANSLATION_LINE_DISPLAY = "(866) 874-3972";

/** National (10-digit) form placed on the clipboard — no "+1", no punctuation. */
export const TRANSLATION_LINE_COPY_VALUE = "8668743972";
